import { tw } from "@careinfo/tailwind";
import grapesjs, { Editor } from "grapesjs";
import "grapesjs/dist/css/grapes.min.css";
import React, { useEffect, useRef } from "react";
import "./style.css";
import { deviceManager } from "../PageEditor/deviceManage";
import NavBar from "./NavBar";
import basicPlugins from "grapesjs-blocks-basic";
import { useModalEditor } from "../../../context/GrapejsModalContext";
import useModalEditorHook from "../../../hooks/useModalEditorHook";
import { accessToken } from "../../../helpers/sessionKey";
import { API_ROOT } from "../../../helpers/AxiosInstance";
import APIS from "../../../constant/Endpoint";
import { useParams } from "react-router-dom";

const GrapesJSEditor: React.FC = () => {
  const editorRef = useRef<Editor | null>(null);
  const containerRef = useRef<HTMLDivElement | null>(null);
  const { setEditor, editor: modalEditor } = useModalEditor();
  const { handleMediaUpload } = useModalEditorHook();
  const { id } = useParams();

  useEffect(() => {
    if (!editorRef.current) {
      const editorInstance = grapesjs.init({
        container: containerRef.current,
        fromElement: true,
        plugins: [basicPlugins],
        panels: { defaults: [] },
        height: "800px",
        width: "auto",
        deviceManager: deviceManager,
        canvas: {
          styles: [
            "https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.css",
          ],
          scripts: [
            "https://careinfo-solutions.s3.ap-south-1.amazonaws.com/tailwind/tailwind.min.js",
            "https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.js",
          ],
        },
        assetManager: {
          assets: [],
          autoAdd: true,
          dropzone: true,
          openAssetsOnDrop: true,
          showUrlInput: true,
          uploadFile: function (ev: any) {
            const files = ev.dataTransfer
              ? ev.dataTransfer.files
              : ev.target.files;
            if (editorRef.current) {
              handleMediaUpload(files, editorInstance);
            }
          },
        },
        storageManager: {
          type: "remote",
          autosave: false,
          autoload: true,
          stepsBeforeSave: 1,
          options: {
            remote: {
              headers: {
                "Content-Type": "application/json",
                Authorization: `JWT ${accessToken()}`,
              },
              urlLoad: `${API_ROOT}${APIS.POPUP}${id}/grapejs_data/`,
            },
          },
        },
        blockManager: {
          appendTo: "#modal-blocks",
          blocks: [
            {
              id: "section",
              label: "<b>Section</b>",
              attributes: { class: "gjs-block-section" },
              content: `<section>
              <h1>This is a simple title</h1>
              <div>This is just a Lorem text: Lorem ipsum dolor sit amet</div>
            </section>`,
            },
          ],
        },
        traitManager: { appendTo: "#modal-trait" },
        styleManager: { appendTo: "#modal-style" },
        selectorManager: { appendTo: "#modal-selector" },
      });
      setEditor(editorInstance);
      editorRef.current = editorInstance;
    }
    return () => {
      if (editorRef.current) {
        editorRef.current.destroy();
        editorRef.current = null;
      }
    };
  }, []);

  return (
    <>
      <NavBar />
      <div className={tw`page flex relative h-[calc(100vh-50px)]`}>
        <div className={tw`w-[200px] sticky top-50 bg-gray-600 overflow-auto`}>
          <div id="modal-blocks" />
        </div>
        <div className={tw`flex-1 overflow-auto sticky top-50 p-4`}>
          <div
            ref={containerRef}
            id="modal-container"
            className={tw`my-1 shadow`}
          />
        </div>
        <div className={tw`w-[200px] bg-gray-600 sticky top-50 overflow-auto`}>
          <div id="modal-selector" />
          <div id="modal-trait" />
          <div id="modal-style" />
        </div>
      </div>
    </>
  );
};

export default GrapesJSEditor;
